import React, { Component } from "react";
import firebase from "../firebase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faMicrophoneSlash,
  faPlay,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { KNOWN_LANGUAGES } from "../utils/Constants"

class RecordingPage extends Component {
  state = {
    sentenceId: 0,
    showDoneModal: false,
    seconds: 0,
    languageDurationRecorded: 0,
    languageRecordingsRecorded: 0,
    totalDurationRecorded: 0,
    totalRecordingsRecorded: 0,
    recording: false,
  };
  known_languages = KNOWN_LANGUAGES.map((lang) => lang.toLowerCase());
  snapshot = null;
  totalSentences = null;
  language = this.props.appState.language;
  userDoc = null;

  async componentDidMount() {
    window.scrollTo(-100, -100)
    let recordAudio = () =>
      new Promise(async (resolve) => {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        const mediaRecorder = new MediaRecorder(stream);
        let audioChunks = [];

        mediaRecorder.addEventListener("dataavailable", (event) => {
          audioChunks.push(event.data);
        });

        const start = () => {
          audioChunks = [];
          mediaRecorder.start();
        };

        const stop = () =>
          new Promise((resolve) => {
            mediaRecorder.addEventListener("stop", () => {
              const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
              const audioUrl = URL.createObjectURL(audioBlob);
              const audio = new Audio(audioUrl);
              const play = () => audio.play();
              resolve({ audioChunks, audioBlob, audioUrl, play });
            });

            mediaRecorder.stop();
          });

        resolve({ start, stop });
      });

    const recordButton = document.getElementById("start");
    const stopButton = document.getElementById("stop");
    const playButton = document.getElementById("play");
    const saveButton = document.getElementById("save");

    let recorder;
    let audio;
    let interval;

    recordButton.addEventListener("click", async () => {
      recordButton.setAttribute("disabled", true);

      if (!recorder) {
        recorder = await recordAudio();
      }
      recorder.start();
      this.setState({ seconds: 0, recording: true });
      interval = setInterval(
        () => this.setState({ seconds: this.state.seconds + 1 }),
        1000
      );
      stopButton.removeAttribute("disabled");
      playButton.setAttribute("disabled", true);
      saveButton.setAttribute("disabled", true);
    });

    stopButton.addEventListener("click", async () => {
      recordButton.removeAttribute("disabled");
      stopButton.setAttribute("disabled", true);
      playButton.removeAttribute("disabled");
      saveButton.removeAttribute("disabled");
      audio = await recorder.stop();
      this.setState({ recording: false });
      clearInterval(interval);
    });

    playButton.addEventListener("click", () => {
      audio.play();
    });

    saveButton.addEventListener("click", () => {
      if (!audio || audio.audioChunks.length === 0) {
        alert("You need to record audio before saving");
        return;
      }
      // Create a root reference
      var storageRef = firebase.storage().ref();

      // Create a reference to 'mountains.jpg'
      const location = this.getLocation(
        [
          this.props.appState.providerId,
          this.props.appState.subjectId,
          this.props.appState.language,
        ],
        [
          this.props.appState.providerId,
          this.props.appState.subjectId,
          this.props.appState.language,
          this.state.sentenceId,
          Date.now(),
        ]
      );
      var storageLocation = storageRef.child(location);

      storageLocation.put(audio.audioBlob).then(() => {
        audio = null;
        recordButton.removeAttribute("disabled");
        stopButton.setAttribute("disabled", true);
        playButton.setAttribute("disabled", true);
        saveButton.setAttribute("disabled", true);
      });

      this.setState(
        {
          sentenceId:
            (this.state.sentenceId + 1) %
            (this.totalSentences == null
              ? this.snapshot.docs.length
              : this.totalSentences),
        },
        () => {
          this.getRandomSentenceFromFirestore(
            this.props.appState.age,
            this.props.appState.language,
            this.state.sentenceId
          );
          this.incementSentenceCounter();
          // Uncomment this to track display sentences in an order
        }
      );
    });
    this.userDoc = await firebase
      .firestore()
      .collection("users")
      .doc(this.props.appState.providerId)
      .collection("subjects")
      .doc(this.props.appState.subjectId)
      .get();
    this.setState(
      {
        sentenceId: this.props.appState.langDocFirestore.data().currentSentence,
        languageDurationRecorded: !this.props.appState.langDocFirestore.data()
          .durationRecorded
          ? 0
          : this.props.appState.langDocFirestore.data().durationRecorded,
        totalDurationRecorded: !this.userDoc.data().durationRecorded
          ? 0
          : this.userDoc.data().durationRecorded,
        languageRecordingsRecorded: !this.props.appState.langDocFirestore.data()
          .recordingsRecorded
          ? 0
          : this.props.appState.langDocFirestore.data().recordingsRecorded,
        totalRecordingsRecorded: !this.userDoc.data().recordingsRecorded
          ? 0
          : this.userDoc.data().recordingsRecorded,
      },
      () =>
        this.getRandomSentenceFromFirestore(
          this.props.appState.age,
          this.props.appState.language,
          this.state.sentenceId
        )
    );
  }

  getLocation = (folder_components, file_components) => {
    let today = new Date()
    var dd = today.getDate();

    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    let folderLoc = "/" + yyyy + "/" + mm + "/" + dd + "/";
    let fileName = "";

    folder_components.forEach((component) => {
      folderLoc = folderLoc + component + "/";
    });

    file_components.forEach((component) => {
      fileName = fileName + "_" + component;
    });

    let location = folderLoc + fileName + ".wav";
    return location;
  };

  incementSentenceCounter = () => {
    this.setState(
      {
        languageDurationRecorded:
          this.state.languageDurationRecorded + this.state.seconds,
        languageRecordingsRecorded: this.state.languageRecordingsRecorded + 1,
        totalDurationRecorded:
          this.state.totalDurationRecorded + this.state.seconds,
        totalRecordingsRecorded: this.state.totalRecordingsRecorded + 1,
      },
      () => {
        firebase
          .firestore()
          .collection("users")
          .doc(this.props.appState.providerId)
          .collection("subjects")
          .doc(this.props.appState.subjectId)
          .collection("languages")
          .doc(this.props.appState.language)
          .update({
            currentSentence: this.state.sentenceId,
            durationRecorded: this.state.languageDurationRecorded,
            recordingsRecorded: this.state.languageRecordingsRecorded,
          });
        firebase
          .firestore()
          .collection("users")
          .doc(this.props.appState.providerId)
          .collection("subjects")
          .doc(this.props.appState.subjectId)
          .update({
            durationRecorded: this.state.totalDurationRecorded,
            recordingsRecorded: this.state.totalRecordingsRecorded,
          });
      }
    );
  };

  copyText = () => {
    var copyText = document.getElementById("subjectId");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    alert("Copied the text: " + copyText.value);
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  render() {
    return (
      <div
        style={{
          display:
            this.props.appState.currentPage === "record" ? "block" : "none",
        }}
      >
        <Modal
          show={this.state.showDoneModal}
          onHide={(e) => this.setState({ showDoneModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              You have submitted {this.state.totalRecordingsRecorded} recordings. Are you sure you want to stop?
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => this.props.setCurrentPage("thank")}
            >
              Yes
            </Button>
            <Button
              variant="primary"
              onClick={(e) => this.setState({ showDoneModal: false })}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>        		
		<div className="flex-container mt-2" style={{ height: "200px" }}>
          <div className="card" style={{ width: "18rem" }}>
            <div className="card-body">
              <b><h5 id="contribution" className="card-title flex-container">
                Your total speech contribution:
              </h5></b>
              <h6 id="contribution_count" className="card-title flex-container">
                No of recordings:

                <div className="flex-container">
                  <b>
                    {this.state.totalRecordingsRecorded}
                  </b>
                </div>
              </h6>
              <div className="flex-container">
                Duration:

                <b>
                  {this.state.languageDurationRecorded}s
                </b>
                ({this.capitalizeFirstLetter(this.props.appState.language)}){","}
                &nbsp;
                <b>
                  {this.state.totalDurationRecorded}s
                </b>
                (Total)


              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: this.isSentenceStimulus(this.props.appState.age, this.props.appState.language) ? "block" : "none",
          }}
        >
          <div
            className="flex-container mt-2"
            style={{
              height: "200px",
            }}
          >
            <div className="card" style={{ width: "18rem" }}>
              <div className="card-body">
                <h5 id="sentence" className="card-title flex-container">
                  Card title
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: this.isSentenceStimulus(this.props.appState.age, this.props.appState.language) ? "none" : "block",
          }}
        >

          <div className="flex-container">
            <h3 id="prompt" className="mt-4">
              {this.getPromptForLanguage(this.props.appState.language)}
            </h3>
          </div>
          <div
            className="flex-container"
            style={{
              height: "",
            }}
          >
		  <img
              id="sentenceImage"
              src="https://via.placeholder.com/400x300"
              alt="Display"
              height="300px"
              style={{ maxWidth: "100%" }}
            ></img>
          </div>
        </div>

        <div className="flex-container">
          <button id="start" className="btn btn-circle btn-xl mr-4 mb-4">
            <FontAwesomeIcon icon={faMicrophone} size="4x" />
            <span style={{ position: "relative" }}>Start recording</span>
          </button>
          <button
            id="stop"
            className="btn btn-circle btn-xl mr-4 mb-4"
            disabled={true}
          >
            <FontAwesomeIcon icon={faMicrophoneSlash} size="4x" />
            <span style={{ position: "relative" }}>Stop recording</span>
          </button>
          <button id="play" className="btn btn-circle btn-xl mr-4 mb-4" disabled={true}>
            <FontAwesomeIcon icon={faPlay} size="4x" />
            <span style={{ position: "relative" }}>Play</span>
          </button>
          <button id="save" className="btn btn-circle btn-xl mr-4 mb-4" disabled={true}>
            <FontAwesomeIcon icon={faSave} size="4x" />
            <span style={{ position: "relative" }}>Save & Continue</span>
          </button>
        </div>
        {/* <br></br>
        <div className="flex-container">
          Add 2 buttons here and uncomment to get 2 buttons in one line and 2 in the next
        </div> */}
        <div className="flex-container mt-5">
          <button
            className="btn btn-dark"
            onClick={() => this.setState({ showDoneModal: true })}
          >
            Quit
          </button>
        </div>
        {this.state.recording ? (
          <div className="text-center mt-5">
            <p>Recording...</p>
            <p>{this.state.seconds}s</p>
          </div>
        ) : null}

        <div className="text-left ml-5">
          <b>Instructions:</b>
          <ul>
            <li>Please start recording by clicking on the start button.</li>
            <li>
              Speak a sentence corresponding to your prompt and click on the stop button to stop
              recording.
            </li>
            <li>
              The recording can be reviewed by clicking on the play button.
            </li>
            <li>
              On reviewing, you can submit the recording by clicking on the save
              button.
            </li>
            <li>
              On successful submission, a new sentence will be displayed.</li>
            <li>
              Repeat the process and submit your speech for every sentence. We recommend you to submit 30 recordings per person.</li>
            <li>
              If you wish to stop for today, you can click on the quit button.
            </li>

          </ul>
        </div>
		
		<div
          style={{
            display:
              this.props.appState.providerId === "Anonymous" ? "block" : "none",
          }}
        >
          <div className="text-left ml-5" style={{ maxWidth: "300px" }}>
            <input
              type="text"
              value={this.props.appState.subjectId}
              id="subjectId"
              readOnly={true}
            ></input>

            <button onClick={this.copyText}>Copy your ID</button>
            <p>
              <small>
                Click on "Copy your ID" to copy your ID. Use this when you
                revisit us for future recordings.
              </small>
            </p>
          </div>
        </div>
      </div>
    );
  }

  isAdult = (age) => {
    let intAge = parseInt(age)
    if (intAge > 12) {
      return false;
    }
    return false;
  }

  isSentenceStimulus = (age, lang) => {
    if (this.known_languages.includes(lang) && this.isAdult(age)) {
      return true;
    }
    return false;
  }

  getPromptForLanguage = (lang) => {
    firebase
      .firestore()
      .collection("Sentences")
      .doc(lang)
      .collection("prompt")
      .doc("prompt")
      .get()
      .then((doc) => {
        document.getElementById("prompt").innerHTML = doc.data().prompt;
      });
  };

  displaySentence = (sentence) => {
    document.getElementById("sentence").innerHTML = sentence;
  };

  displayImage = (age, lang, sentenceId) => {
    firebase
      .storage()
      .ref(this.getImageLoc(age, lang, sentenceId))
      .getDownloadURL()
      .then((url) => {
        document.getElementById("sentenceImage").src = url;
      });
  };

  getFolderLoc = (age, lang) => {
    if (this.isAdult(age)) {
      return "Stimuli"
    }

    return "Stimuli";
  };

  getImageLoc = (age, lang, sentenceId) => {
    return this.getFolderLoc(age, lang) + "/" + sentenceId + ".jpg";
  };

  getAdultSentence = (lang, sentenceId) => {
    if (this.snapshot == null || this.language !== lang) {
      this.language = lang;
      firebase
        .firestore()
        .collection("Sentences")
        .doc(lang)
        .collection("text")
        .get()
        .then((snapshot) => {
          this.snapshot = snapshot;

          sentenceId = Math.floor(Math.random() * snapshot.docs.length);
          this.setState({ sentenceId: sentenceId });

        })
        .then(() => {
          this.snapshot.docs.forEach((doc) => {
            if (doc.data().id === sentenceId) {
              this.displaySentence(doc.data().sentence);
            }
          });
        });
    } else {
      this.snapshot.docs.forEach((doc) => {
        if (doc.data().id === sentenceId) {
          this.displaySentence(doc.data().sentence);
        }
      });
    }
  };

  getImage = (age, lang, sentenceId) => {
    if (this.totalSentences !== null) {
      this.displayImage(age, lang, sentenceId + 1);
    } else {
      firebase
        .storage()
        .ref(this.getFolderLoc(age, lang))
        .list()
        .then((images) => {
          this.totalSentences = images.items.length;
          sentenceId = sentenceId % this.totalSentences;
          this.displayImage(age, lang, sentenceId + 1);
        });
    }
  };

  getRandomSentenceFromFirestore = (age, lang, sentenceId) => {
    if (this.isSentenceStimulus(this.props.appState.age, this.props.appState.language)) {
      this.getAdultSentence(lang, sentenceId);
    }
    else {
      this.getImage(age, lang, sentenceId);
    }
  };

}

export default RecordingPage;
